"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logoutFromMovistar = exports.logoutConvergente = exports.logoutTELCO = void 0;
const logoutTELCO = (url) => {
    document.location.assign(url);
    return null;
};
exports.logoutTELCO = logoutTELCO;
/**
 * Cierra sesión de usuario.
 */
const logoutConvergente = (url) => {
    localStorage.removeItem('codigoOrden');
    localStorage.removeItem('numtlf');
    sessionStorage.removeItem('nameuser');
    sessionStorage.removeItem('urlhomeprivada');
    sessionStorage.removeItem('cclivr$$.api.misDatos');
    document.location.assign(url);
};
exports.logoutConvergente = logoutConvergente;
const logoutFromMovistar = ({ backToHome = false, userType, pautLogout = false, }) => {
    let urlToGo = backToHome
        ? 'https://www.movistar.es/mimovistar-cliente/es-es/particulares/cclivr/logout.html?destino=https%3A%2F%2Fwww.movistar.es%2F'
        : `https://www.movistar.es/mimovistar-cliente/es-es/particulares/cclivr/logout.html?destino=${window.location.href}`;
    if (!backToHome && pautLogout) {
        urlToGo = backToHome
            ? 'https://www.movistar.es/mimovistar-cliente/es-es/particulares/cclivr/logout.html?destino=https%3A%2F%2Fwww.movistar.es%2F'
            : 'https://www.movistar.es/mimovistar-cliente/es-es/particulares/cclivr/logout.html?destino=https%3A%2F%2Fpaut.telefonica.es%2Flogout';
    }
    if (userType === 'Telco') {
        (0, exports.logoutTELCO)(urlToGo);
    }
    else if (userType === 'Legado') {
        (0, exports.logoutConvergente)(urlToGo);
    }
    sessionStorage.removeItem('cmsNameUser');
    sessionStorage.removeItem('cmsIsPriority');
    sessionStorage.removeItem('cmsContext');
};
exports.logoutFromMovistar = logoutFromMovistar;
//# sourceMappingURL=logingUtils.js.map